<div class="modal-header">
    <h4 class="modal-title">{{'Generate report'|translate}}</h4>
</div>

<div class="modal-body text-left">
    <!-- Loader -->
    <div *ngIf="isLoading" class="load-spinner text-center py-8">
        <i class="fa fa-spinner fast-pulse text-xl text-gray-600" aria-hidden="true"></i>&nbsp;
        {{ 'The report is generating, please wait' | translate }}
    </div>

    <!-- Formularz wyboru miesiąca -->
    <ng-container *ngIf="!isLoading">
        <h2 class="text-2xl font-semibold mb-4 text-gray-800">{{'Select month'|translate}}:</h2>

        <div class="mb-4">
            <select
                class="px-3 py-2 w-60 custom-select border border-gray-300 rounded focus:outline-none focus:ring focus:border-blue-500"
                [formControl]="monthControl">
                <option *ngFor="let month of months" [value]="month.value">
                    {{ month.label }}
                </option>
            </select>
        </div>
    </ng-container>
</div>

<div class="modal-footer flex justify-between items-center pt-2 border-t border-gray-200">
    <button class="btn btn-white btn-sm" (click)="close()" [disabled]="isLoading">
        {{'Close'|translate}}
    </button>

    <button class="btn btn-primary btn-sm btn-uppercase" (click)="generate()" [disabled]="isLoading">
        {{ isLoading ? ('Please, wait!' | translate) : 'Generate' | translate }}
    </button>
</div>